module.exports = __webpack_public_path__ + "img/pick4.93a55885.png";